module.exports = require('react');



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/react.js
// module id = 15
// module chunks = 0 1 2 3 4